<template>
  <div class="flags">
    <div class="head row align-center column-s">
      <h1>FLAGS</h1>
      &nbsp;&nbsp;&nbsp;
      <Button
        :layout="showForm ? 'red-go' : 'green-go'"
        title="NOVA FLAG"
        @click="showForm = !showForm"
        >{{ showForm ? "x" : "+" }}</Button
      >
      <transition name="slide">
        <div v-if="showForm" class="new grid-11">
          <FlagForm :form="form" />
        </div>
      </transition>
    </div>
    <div class="list">
      <div v-if="loader" class="column align-center justify-center">
        <Loader layout="small" />
      </div>
      <template v-else>
        <input class="input search" v-model="search" placeholder="Pesquisar" />

        <div class="head row justify-space">
          <div class="grid-1">ID</div>
          <div class="grid-1">Prioridade</div>
          <div class="grid-2">Filtro</div>
          <div class="grid-2">Flag</div>
          <div class="grid-2">Descrição</div>
          <div class="grid-1">Criado</div>
          <div class="grid-1">Alterado</div>
        </div>
        <div class="content">
          <div v-for="(item, i) of filtered" :key="'item' + i">
            <div class="line row justify-space" @click="toggle(i)">
              <div class="grid-1">{{ item.id }}</div>
              <div class="grid-1">{{ item.prioridade }}</div>
              <div class="grid-2">{{ item.filtro }}</div>
              <div class="grid-2">{{ item.flag }}</div>
              <div class="grid-2">{{ item.descricao }}</div>
              <div class="grid-1">{{ item.criado_em | date }}</div>
              <div class="grid-1">{{ item.alterado_em | date }}</div>
            </div>
            <div v-if="item.show" class="edit row wrap column-s">
              <FlagForm v-if="item.show" :form="item" />
              <Loader layout="small" v-else />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";
import FlagForm from "@/views/admin/components/FlagForm.vue";

export default {
  name: "Flags",
  components: {
    Button,
    FlagForm,
    Loader,
  },
  data() {
    return {
      loader: true,
      showForm: false,
      form: { send: this.create },
      search: "",
      list: [],
    };
  },
  methods: {
    ...mapActions("admin", ["FLAGS_CREATE", "FLAGS_DEL", "FLAGS_UPDATE", "FLAGS_LIST"]),
    async load() {
      this.loader = true;
      await this.FLAGS_LIST({}).then(({ data }) => (this.list = data));
      this.loader = false;
    },
    create(form) {
      return this.FLAGS_CREATE(form).then(() => this.load());
    },
    del(item) {
      if (confirm(`Deseja excluir ${item.flag}?`)) {
        return this.FLAGS_DEL(item.id).then(() => this.load());
      }
    },
    update(item) {
      this.FLAGS_UPDATE({ ...item, params: item.id }).then(({ status }) => {
        if (status == 200) this.load();
      });
    },
    async toggle(index) {
      this.list[index].show = !this.list[index].show;
      this.list[index].update = true;
      this.list[index].send = () => this.update(this.list[index]);
      this.list[index].del = () => this.del(this.list[index]);
      this.list = [...this.list];
      /* if (this.list[index].show) {
        this.BASISCOST_LIST().then(({ data }) => (this.basisCost = data));
        await this.FLAGS_GET(this.list[index].id).then(({ data }) => {
          this.list[index].update = true;
          this.list[index].info = data;
          this.list[index].send = () => this.update(this.list[index]);
          this.list[index].del = () => this.del(this.list[index]);
          this.list = [...this.list];
        });
      } */
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("flags");
    this.load();
  },
  computed: {
    filtered() {
      if (this.search) {
        const search = this.search.toLowerCase();

        return this.list.filter((part) => {
          let partsSerialize = JSON.stringify(part).toLowerCase();
          return partsSerialize.includes(search);
        });
      } else {
        return this.list;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.flags
    @include page
</style>
